import { createContext } from 'react';
import { EntityAttributesContextType } from './EntityAttributesTypes';

export const EntityAttributesContext =
    createContext<EntityAttributesContextType | null>(null);
